.lab {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg, 24px);
  padding: var(--spacing-md, 16px) 0;
}

.controls {
  display: inline-flex;
  gap: var(--spacing-md, 16px);
  flex-wrap: wrap;
}

.button {
  min-height: 44px;
  padding: var(--spacing-sm, 8px) var(--spacing-md, 16px);
  border: var(--border-width, 1px) solid var(--border-color, #ccc);
  background: transparent;
  cursor: pointer;
  border-radius: var(--radius-sm, 4px);
}

.buttonPrimary {
  composes: button;
  background: var(--primary, #1976d2);
  color: var(--primary-contrast, #fff);
  border-color: var(--primary, #1976d2);
}
